import { render } from "./Fathers.vue?vue&type=template&id=2747ff92"
import script from "./Fathers.vue?vue&type=script&lang=js"
export * from "./Fathers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__